import React from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';

import IconComponent from 'assets/icons';
import styles from './CheckLabel.module.scss';

type CheckLabelType = 'Flat' | 'Circle';

interface CheckLabelProps {
  /** @boolean - CheckLabel checked boolean */
  checked?: boolean;
  /** @string - Classname to be applied to the parent element */
  className?: string;
  /** @string - Classname to be applied to the icon */
  iconClassName?: string;
  /** @string - Classname to be applied to the input */
  inputClassName?: string;
  /** @function - Called when the CheckLabel value changes */
  onChange?: (checked: boolean) => void;
  /** @function - Called when the CheckLabel is clicked */
  onClick?: () => void;
  /** @string - Custom 'data-cy' attribute for the test runner */
  testSelector?: string;
  /** @string - Checklabel style preset */
  type?: CheckLabelType;
}

const Icon = IconComponent as any;

const CheckLabel: React.FC<CheckLabelProps> = ({
  checked,
  children,
  className,
  iconClassName,
  inputClassName,
  onChange = noop,
  onClick,
  testSelector,
  type,
}) => (
  <label
    data-cy={testSelector}
    className={classnames(className, styles.checkLabel, styles[`type-${type}`])}
  >
    <input
      checked={!!checked}
      className={styles.checkInput}
      type="checkbox"
      onClick={onClick}
      onChange={(event) => onChange && onChange(event.target.checked)}
    />

    <div className={classnames(inputClassName, styles.fakeInput)} />
    <Icon.Checkmark className={classnames(iconClassName, styles.checkmark)} />

    {children}
  </label>
);

export default CheckLabel;
